<template>
  <div class="ui large modal" ref="modal">
    <div class="header">{{ title }}</div>
    <div class="scrolling content">
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <table class="ui striped table">
              <thead>
                <tr>
                  <th></th>
                  <th>Data</th>
                  <th>Evento</th>
                  <th>Cadastro</th>
                  <th>ID</th>
                  <th>Descrição</th>
                </tr>
              </thead>
              <tbody>
                <div
                  class="neutral"
                  v-for="(version, index) in versions"
                  :key="index"
                >
                  <tr>
                    <td class="center aligned">
                      <a
                        v-show="Object.keys(version.item_changes).length > 0"
                        @click.prevent="open_details($event)"
                        ><i class="caret right icon"></i
                      ></a>
                    </td>
                    <td>
                      {{ getFormattedDate(version.created_at) }}
                    </td>
                    <td>{{ getEventEnum(version.event) }}</td>
                    <td>{{ (version.who || {})['name'] }}</td>
                    <td>{{ (version.who || {})['id'] }}</td>
                    <td>{{ version.message }}</td>
                  </tr>
                  <tr class="details hide">
                    <td colspan="6">
                      <div class="ui segment">
                        <table class="ui very basic table">
                          <thead>
                            <th>Campo</th>
                            <th>Antes</th>
                            <th>Depois</th>
                          </thead>
                          <tbody>
                            <div
                              v-if="version.event == 'destroy'"
                              class="neutral"
                            >
                              <tr
                                v-for="version_key in Object.keys(
                                  version.obj.keys
                                )"
                                :key="version_key"
                              >
                                <td class="bold">{{ version_key }}</td>
                                <td>{{ version.obj[version_key] }}</td>
                                <td></td>
                              </tr>
                            </div>

                            <div
                              v-if="version.event != 'destroy'"
                              class="neutral"
                            >
                              <tr
                                v-for="change_key in Object.keys(
                                  version.item_changes
                                )"
                                :key="change_key"
                              >
                                <td class="bold">{{ change_key }}</td>
                                <td>
                                  {{ version.item_changes[change_key][0] }}
                                </td>
                                <td>
                                  {{ version.item_changes[change_key][1] }}
                                </td>
                                <td></td>
                              </tr>
                            </div>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/resources/Api';
import moment from 'moment';
import historyEnum from '@/enumerations/history_enum.js';

export default {
  props: {
    title: {
      type: String,
      default: 'Histórico'
    },

    resource: {
      type: String
    },

    item_id: {
      type: Number
    }
  },

  data() {
    return {
      loading: false,
      versions: []
    };
  },

  methods: {
    open() {
      window.$(this.$refs.modal).modal('show');
      this.search();
    },

    hide() {
      window.$(this.$refs.modal).modal('hide');
    },

    open_details(evt) {
      var $icon = window.$(evt.target);
      var $details = $icon.closest('tr').next('tr.details');
      if ($icon.hasClass('right')) {
        $icon.removeClass('right');
        $icon.addClass('down');

        $details.removeClass('hide');
      } else {
        $icon.removeClass('down');
        $icon.addClass('right');

        $details.addClass('hide');
      }
    },

    search(page = 1) {
      const query = {
        q: {
          item_type_eq: this.resource,
          item_id_eq: this.item_id,
          s: ['updated_at asc']
        },
        page: page
      };

      this.loading = true;
      Api.versions
        .search(query)
        .then(async response => {
          this.versions = _.clone(response.data.versions);
        })
        .catch(error => {
          this.$toast.show('Erro ao carregar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getEventEnum(event) {
      const { description } = historyEnum.events.find(
        eventFind => eventFind.value === event
      );
      return description;
    },

    getFormattedDate(date) {
      const formattedDate = moment(date)
        .locale('pt')
        .format('ddd[,] DD [de] MMMM [de] YYYY[,] HH:mm:ss');
      return formattedDate;
    }
  }
};
</script>
